import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import { FORM_ERROR } from "final-form";
import Modal from "components/Modal/Modal";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import ModalFooterLeft from "components/Modal/ModalFooterLeft";
import ModalFooterRight from "components/Modal/ModalFooterRight";
import Button from "components/Button/Button";
import { findFarms, updateFarmGroup } from "./_actions";
import FarmGroupDetails from "./FarmGroupDetails";

const validate = (farmGroup) => {
    const error = {};
    error.name = FormUtils.validators.required(farmGroup.name);
    error.name = error.name || FormUtils.validators.maxLength(50)(farmGroup.name);
    error.description = FormUtils.validators.maxLength(100)(farmGroup.description);
    error.farmGroupVisibility = FormUtils.validators.required(farmGroup.farmGroupVisibility);
    error.showAggregatedReport = !farmGroup.showBenchmarkReport && !farmGroup.showAggregatedReport ? "At lease one report type needs to be selected" : undefined;
    return error;
};

const submit = (updateFarmGroup, close) => async (farmGroup) => {
    if (farmGroup.farmGroupVisibility === "Private") {
        farmGroup.showAggregatedReport = true;
        farmGroup.showBenchmarkReport = true;
        farmGroup.showMembers = true;
    }
    const submitResult = await updateFarmGroup(farmGroup)
        .then(() => close())
        .catch((error) => ({ [FORM_ERROR]: error }));

    return submitResult;
};

const FarmGroupDetailsModal = ({ farmGroup, updateFarmGroup, close, refData }) => {
    return (
        <Form initialValues={farmGroup} validate={validate} onSubmit={submit(updateFarmGroup, close)}>
            {({ handleSubmit, pristine, submitting, submitError, dirtySinceLastSubmit, values }) => {
                return (
                    <form onSubmit={handleSubmit}>
                        <Modal title="Edit farm group" close={close} submitting={submitting}>
                            <ModalBody>
                                <FarmGroupDetails refData={refData} submitError={submitError} dirtySinceLastSubmit={dirtySinceLastSubmit} values={values} />
                            </ModalBody>
                            <ModalFooter>
                                <ModalFooterLeft>
                                    <Button id="btnFarmGroupDetails_cancel" onClick={close} secondary disabled={submitting}>
                                        Cancel
                                    </Button>
                                </ModalFooterLeft>
                                <ModalFooterRight>
                                    <Button id="btnFarmGroupDetails_save" submit primary disabled={pristine || submitting}>
                                        Save
                                    </Button>
                                </ModalFooterRight>
                            </ModalFooter>
                        </Modal>
                    </form>
                );
            }}
        </Form>
    );
};
export default compose(withAppContext, withActions({ findFarms, updateFarmGroup }))(FarmGroupDetailsModal);
